export default __webpack_public_path__ + "static/media/best-seller-two.65b04ba4.jpg";